module.exports = __webpack_public_path__ + "img/horizontal_4_6_3016.508a9b36.png";